import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column align-items-end" }
const _hoisted_2 = {
  key: 0,
  class: "text-end mb-2"
}
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = { class: "countdown-message" }
const _hoisted_5 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_6 = {
  key: 1,
  class: "text-end mb-2"
}
const _hoisted_7 = { class: "d-flex gap-2" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

import { computed, toRef } from "vue";
import VueCountdown from "@chenfengyuan/vue-countdown";
import BookingCountdownText from "./BookingCountdownText.vue";
import { useBookingModificationWindow } from "../../composables/useBookingModificationWindow.js";


export default {
  __name: 'BookingViewActions',
  props: {
	booking: { type: Object, default: null },
	show: { type: Boolean, default: false },
	isLoading: { type: Boolean, default: false },
},
  emits: ["close", "edit", "delete", "end-walkin"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const {
	userRole,
	canEditWithTime,
	canDeleteWithTime,
	canEndWalkIn,
	walkInEndNoLongerPossible,
	editCountdownConfig,
	shouldShowEditModeCountdown,
	handleEditCountdownExpired,
} = useBookingModificationWindow({
	booking: toRef(props, "booking"),
	show: toRef(props, "show"),
});

const isWalkInBooking = computed(() => !!props.booking?.walkIn);

// Walk-in: no generic edit or delete for students (extend side door), they use Beenden only;
// staff may still edit and delete for cleanup.
const isStudentWalkIn = computed(
	() => isWalkInBooking.value && userRole.value === "student",
);
const showEditButton = computed(
	() => canEditWithTime.value && !isStudentWalkIn.value,
);
const showDeleteButton = computed(
	() => canDeleteWithTime.value && !isStudentWalkIn.value,
);

const showEditCountdown = computed(
	() => !isWalkInBooking.value && shouldShowEditModeCountdown("view"),
);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showEditCountdown.value && _unref(editCountdownConfig))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("small", _hoisted_3, [
            (_unref(editCountdownConfig).time > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(editCountdownConfig).message), 1 /* TEXT */),
                  _createVNode(_unref(VueCountdown), {
                    time: _unref(editCountdownConfig).time,
                    onEnd: _unref(handleEditCountdownExpired)
                  }, {
                    default: _withCtx((timeLeft) => [
                      _createVNode(BookingCountdownText, _mergeProps(timeLeft, {
                        "text-class": `text-${_unref(editCountdownConfig).warningLevel}`
                      }), null, 16 /* FULL_PROPS */, ["text-class"])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["time", "onEnd"])
                ], 64 /* STABLE_FRAGMENT */))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("i", { class: "fas fa-exclamation-triangle me-1" }, null, -1 /* CACHED */),
                  _createTextVNode(" Bearbeitung und Löschung nicht mehr möglich ", -1 /* CACHED */)
                ]))]))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_unref(walkInEndNoLongerPossible))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("small", { class: "text-muted" }, [
            _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
            _createTextVNode(" Diese Sofortbuchung kann nicht mehr beendet werden. ")
          ], -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: __props.isLoading,
        onClick: _cache[0] || (_cache[0] = $event => (emit('close')))
      }, " Schließen ", 8 /* PROPS */, _hoisted_8),
      _createCommentVNode(" Walk-in: students get no edit/delete side door — only Beenden while running "),
      (showEditButton.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            disabled: __props.isLoading,
            onClick: _cache[1] || (_cache[1] = $event => (emit('edit')))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */),
            _createTextVNode(" Bearbeiten ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_9))
        : _createCommentVNode("v-if", true),
      (showDeleteButton.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "button",
            class: "btn btn-danger",
            disabled: __props.isLoading,
            onClick: _cache[2] || (_cache[2] = $event => (emit('delete')))
          }, [...(_cache[7] || (_cache[7] = [
            _createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* CACHED */),
            _createTextVNode(" Löschen ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_10))
        : _createCommentVNode("v-if", true),
      (_unref(canEndWalkIn) || _unref(walkInEndNoLongerPossible))
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            type: "button",
            class: "btn btn-warning",
            disabled: __props.isLoading || _unref(walkInEndNoLongerPossible),
            onClick: _cache[3] || (_cache[3] = $event => (emit('end-walkin')))
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", { class: "fas fa-stop" }, null, -1 /* CACHED */),
            _createTextVNode(" Beenden ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_11))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}
}

}